.app {
    height: 100%;
    padding: var(--spacing-6) var(--spacing-8);
    display: flex;
    flex-direction: column;
}
